import { IonButtons, IonButton, IonContent, IonFooter, IonHeader, IonModal, IonTitle, IonToolbar } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { createUseStyles } from 'react-jss';
import { NoteBodyConflictPresenter } from './NoteBodyConflictPresenter';
import { SelectableText } from '../../components/SelectableText';

const useStyles = createUseStyles({
    // preserve the body's line breaks the way the note list does, so the user can compare
    // their version (in the editor behind this) with theirs line by line
    body: {
        padding: 16,
        whiteSpace: 'pre-wrap'
    }
});

// Globally mounted (in InnerhiveApp). Renders the read-only "their version" of a note body when a
// body conflict is active, and reports the user's Keep-mine / Use-theirs choice back to the presenter.
// Not backdrop-dismissable, so Save stays blocked until the user chooses.
export const NoteBodyConflictDrawer: React.FC = () => {
    const presenter = useInstance(NoteBodyConflictPresenter);
    useSubscription(() => presenter);
    const classes = useStyles();

    const theirsHtml = presenter.getActiveTheirsHtml();

    return (
        <IonModal isOpen={Boolean(theirsHtml)} backdropDismiss={false} data-id="note-body-conflict-drawer">
            <IonHeader>
                <IonToolbar>
                    <IonTitle>The note body was changed by someone else</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <div className={`mp-mask ${classes.body}`}>
                    <SelectableText>{theirsHtml || ''}</SelectableText>
                </div>
            </IonContent>
            <IonFooter>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton fill="clear" data-id="keep-mine-button" onClick={() => presenter.choose('mine')}>Keep mine</IonButton>
                    </IonButtons>
                    <IonButtons slot="end">
                        <IonButton data-id="use-theirs-button" onClick={() => presenter.choose('theirs')}>Use theirs</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
};
